import getJSONFromPage from "./getJSONFromPage"
import getJSONFromStorage from "./getJSONFromStorage"

/**
 * [getJSON]
 * optionally removes name question for AB test
 * @return {object} - JSON object from script
 */
const getJSON = () => {
  let res = getJSONFromPage() || getJSONFromStorage()
  // name removal. todo remove in version 6
  if(res?.intro && (res?.intro[0]?.compType === 'basicNameQuestion')){
    res?.intro?.shift()
  }

  /*
   * age removal if found in url
   * NT2-24708  AB Test | Quiz CTA on Woman PCP - 7/8
   */
  if(typeof  window !== "undefined" && res?.sections){
    const params = new URLSearchParams(window.location.search)
    const agePreset = params.get('age')
    if(agePreset){
      res.sections[0].questions = res.sections[0].questions.filter(el=>el.globalid !== "age")
    }
  }

  //console.log('res', res)

  return res
}

export default getJSON
